import { render, staticRenderFns } from "./Zusatzbeitrag.vue?vue&type=template&id=ae3922da&"
import script from "./Zusatzbeitrag.vue?vue&type=script&lang=js&"
export * from "./Zusatzbeitrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports